import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import moment from 'moment'
import {
   Table, Menu, Label, Dropdown,
   Segment, Input, Pagination,
   Message, Form, Select, Icon, Button, Header
} from 'semantic-ui-react';
import _ from 'lodash';
import ModalDetail from '../../opd/_sts/ModalDetail';
import ExportModal from './ExportModal'
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import { isBank, isAdmin, isVerificator, getTahunAnggaran } from '../../../../../_utils/localstorage';
import ModalEdit from '../../opd/_sts/ModalEdit';
import DateModalVerif from './DateModalVerif';
import swal from 'sweetalert'
import { toIDR } from '../../../../../_utils/tocurrency';


export default class STSList extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         direction: null,
         requests: true,
         activePage: 1,
         totalPages: 0,
         itemPerPage: 0,
         totalItem: 0,
         q: "",

         is_detail: false,
         data_detail: null,
         loading_detail: false,

         is_edit: false,
         data_edit: null,
         loading_edit: false,

         is_verif: false,
         data_verif: null,
         loading_verif: false,

         is_export: false,
         isFilter: false,

         focused: null,
         startDate: null,
         endDate: null,
         status: 2,
         focusedInput: null,
         pageActive: 1,
         checkSTSBermasalah: false,
         processing: 0,
         dataLength: 0,
         resultBermasalah: false
      }

      this.searchSTS = this.searchSTS.bind(this);
      this.onCloseDetail = this.onCloseDetail.bind(this);
      this.onOpenDetail = this.onOpenDetail.bind(this);
      this.onFilter = this.onFilter.bind(this);
      this.onCloseExport = this.onCloseExport.bind(this);
      this.onOpenExport = this.onOpenExport.bind(this);

      this.onCloseVerif = this.onCloseVerif.bind(this);
      this.onOpenVerif = this.onOpenVerif.bind(this);

      this.onRefresh = this.onRefresh.bind(this);
      this.onOpenEdit = this.onOpenEdit.bind(this);
      this.onCloseEdit = this.onCloseEdit.bind(this);
      this.onOpenBatalkan = this.onOpenBatalkan.bind(this);
      this.onOpenUnverified = this.onOpenUnverified.bind(this);
      this.onChangeStatus = this.onChangeStatus.bind(this);
      this.onCheckStatus = this.onCheckStatus.bind(this);
      this.onVerifikasiAdmin = this.onVerifikasiAdmin.bind(this);


   }

   onOpenEdit = (e, { index }) => {
      const { data } = this.state
      this.setState({
         is_edit:true,
         data_edit:data[index],
         loading_edit:false
      });
   }

   onOpenBatalkan = (e, {index}) => {

      let sts_data = this.state.data[index];

      swal({
         title: `Benar STS ini akan dibatalkan?`,
         text: "Apakah anda tetap melanjutkan?",
         icon: "warning",
         buttons: true,
         dangerMode: true,
      })
      .then((will) => {
         if (will) {
            this.setState({ requests: true });
            fetch(`${BaseURLDev}/sts`,{
               method: 'DELETE',
               headers,
               body: JSON.stringify({
                  sts_data: sts_data
               })
            })
            .then(response => {
               if (!response.ok) {
                  this.setState({ requests: false });
                  swal("STS gagal dibatalkan", {
                     icon: "error",
                  });
                  return Promise.reject(response.statusText);
               }
               return response.json()
            })
            .then(parsedJSON => {
               swal("STS sukses dibatalkan","Proses STS", "success")
               // this.setState({ requests: false });
               this.onLoadData();
            })
         }
      })
   }

   onOpenUnverified = (e, {index}) => {

      let sts_data = this.state.data[index];

      swal({
         title: `Benar STS ini akan direset?`,
         text: "Apakah anda tetap melanjutkan?",
         icon: "warning",
         buttons: true,
         dangerMode: true,
      })
      .then((will) => {
         if (will) {
            this.setState({ requests: true });
            fetch(`${BaseURLDev}/sts`,{
               method: 'PUT',
               headers,
               body: JSON.stringify({
                  sts_data: sts_data
               })
            })
            .then(response => {
               if (!response.ok) {
                  this.setState({ requests: false });
                  swal("Reset STS gagal", {
                     icon: "error",
                  });
                  return Promise.reject(response.statusText);
               }
               return response.json()
            })
            .then(parsedJSON => {
               swal("Reset STS sukses","Proses STS", "success")
               this.onLoadData();
               // this.setState({ requests: false });
            })
         }
      })
   }

   onCloseEdit = () => {
      this.onRefresh();
      this.setState({
         is_edit:false,
         data_edit:null
      });
   }

   onRefresh(){
      this.setState({
         startDate: null,
         endDate: null,
         q: "",
         requests: true,
         status: 2
      })

      fetch(`${BaseURLDev}/stsall?status=${this.state.status}`, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({data: [], requests: false});
            swal("Mohon periksa koneksi internet anda", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
      .catch(e => {
         this.setState({requests: false})
         swal("Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
            icon: "error",
         });
      })
   }

   verifikasiUlangSTS(no_sts){
      
      swal({
         title: "Apakah anda yakin?",
         text: "STS ini akan diverifikasi ulang dan langsung divalidasi ke server SIMDA!",
         icon: "warning",
         buttons: true,
         dangerMode: true,
      })
      .then((verif) => {
         if (verif) {
            this.setState({requests:true});
            fetch(`${BaseURLDev}/postsimda/verifikasibpkad`,{
               method: 'POST',
               headers,
               body: JSON.stringify({
                  no_sts: no_sts,
                  date: null
               })
            })
            .then(response => {
               if (!response.ok) { 
                  this.setState({requests:false});
                  swal("Verifikasi STS gagal", {
                     icon: "error",
                  });
                  return Promise.reject(response.statusText);
               }
               return response.json()
            })
            .then(parsedJSON => {
               this.setState({
                  requests: false
               });
               swal("Verifikasi STS selesai", {
                  icon: "success",
               }).then(()=>{
                  window.location.href="/a/sts"
               });
            })
         } else {
            return false
         }
      });
   }

   onFilter(){
      let { startDate, endDate, status } = this.state
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');

      // change value from status bermasalah to terverifikasi
      if (status == 3) {
         this.setState({checkSTSBermasalah: true});
      } else {
         this.setState({checkSTSBermasalah: false});
      }

      this.setState({ requests: true, isFilter: true, q: "" })
      fetch(`${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status == 3 ? 1 : status}`, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({data:[],requests:false});
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }

   onOpenDetail = async (e, { index }) => {
      await this.setState({
         is_detail: true,
         data_detail: this.state.data[index],
         loading_detail: false
      })
   };

   onCloseDetail = () => this.setState({is_detail: false, data_detail: null});

   onCloseExport = () => this.setState({is_export: false})
   onOpenExport = () => this.setState({is_export: true})

   onCloseVerif = () => this.setState({is_verif: false, data_verif: null})
   onOpenVerif = (e, {index}) => this.setState({is_verif: true, data_verif: this.state.data[index]})

   handleSort = clickedColumn => () => {
      const { column, data, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         data: data.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }

   onLoadData(){
      this.setState({ requests: true });
      fetch(`${BaseURLDev}/stsall?status=${this.state.status}`, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({ data: [], requests: true });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
      .catch(e => {
         swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
            icon: "error",
         });
      })
   }

   defaultState = async (stateData) => {
      this.setState({dataLength: stateData.data.length});
      await this.setState({
         data: stateData.data,
         totalPages: stateData.totalPage,
         requests: false,
         totalItem: stateData.totalItem,
         itemPerPage: stateData.itemPerPage,
         isFilter: false,
         processing: 0,
         checkSTSBermasalah: false,
         resultBermasalah: false
      })
   };

   componentDidMount(){
      this.onLoadData();
   }

   handlePaginationChange = (e, { activePage }) => {
      if (this.state.pageActive === activePage){
         return false;
      }

      const { startDate, endDate, status } = this.state
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

      this.setState({ activePage, pageActive: activePage, requests: true, isFilter: true })
      var url = null;
      if(this.state.q !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&page=${activePage}&q=${this.state.q}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&page=${activePage}`
      }

      fetch(url,{ headers })
      .then(response => {
         if(!response.ok){
            this.setState({ data: [], requests: false });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }

   searchSTS(e) {
      this.setState({ q: e.target.value, requests: true });
      const { startDate, endDate, status } = this.state;
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD');
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
      var url = null;
      if(e.target.value !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&q=${e.target.value}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}`
      }

      fetch(url, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({ requests: false });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }


   onChangeStatus(e, el){
      // change value from status bermasalah to terverifikasi
      if (el.value == 3) {
         this.setState({checkSTSBermasalah: true});
      } else {
         this.setState({checkSTSBermasalah: false});
      }

      this.setState({ status: el.value, requests: true, isFilter: true });
      const { startDate, endDate, q } = this.state;
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD');
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
      var url = null;
      if(q !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${el.value == 3 ? 1 : el.value}&q=${q}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${el.value == 3 ? 1 : el.value}`
      }

      fetch(url, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({ requests: false });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }

   onVerifikasiAdmin(e, { index }){
      swal({
         text: "Benar akan diverifikasi?",
         icon: "warning",
         buttons: true,
         dangerMode: true,
       })
      .then((willVerified) => {
         if (willVerified) {
            this.setState({ requests: true });
            fetch(`${BaseURLDev}/postsimda/verifikasiadm/${this.state.data[index].public_id}`,{
               method: 'POST',
               headers,
               body: JSON.stringify({
                  date: null
               })
            })
            .then(response => {
               if (!response.ok) {
                  this.setState({ requests: false });
                  swal("Verifikasi STS ke SIMDA gagal", {
                     icon: "error",
                  });
                  return Promise.reject(response.statusText);
               }
               return response.json()
            })
            .then(parsedJSON => {
               swal("Verifikasi STS ke SIMDA","Verifikasi STS Sukses", "success")
               this.setState({ requests: false });
            })
         }
      });
   }

   checkSTSValid = () => {
      let sts = this.state.data;
      console.log(sts)
   };

   onCheckStatus(e, { index }){
      this.setState({ requests: true });
      fetch(`${BaseURLDev}/postsimda/checkstatus`,{
         method: 'POST',
         headers,
         body: JSON.stringify({
            no_sts: this.state.data[index].no_sts
         })
      })
      .then(response => {
         if (!response.ok) {
            this.setState({ requests: false });
            swal("Validasi STS gagal", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(parsedJSON => {
         const data_json = parsedJSON.data;
         if(data_json.data!==null && data_json.error_network===false && data_json.error_data===false)
            swal("Validasi STS", `STS ${parsedJSON.no_sts} telah terdaftar di database SIMDA dengan Nomor BKU ${data_json.data.no_bku}`,"success")
         else if(data_json.data===null && data_json.error_network===true && data_json.error_data===false)
            swal("Validasi STS", "Maaf Jaringan SIMDA sedang bermasalah", "error")
         else if(data_json.data===null && data_json.error_network===false && data_json.error_data===true)
            swal("Validasi STS", `Maaf STS ${parsedJSON.no_sts} tidak ditemukan di database SIMDA`, "error")

         this.setState({ requests: false });
      })
   }

   render() {
      const { dataLength, processing, column, data, direction, activePage, startDate, endDate, requests, isFilter } = this.state;
      const status_opt = [
         {'key': 0, 'text': 'Terverifikasi', 'value': 1},
         {'key': 1, 'text': 'Belum Terverifikasi', 'value': 0},
         {'key': 2, 'text': 'Semua Status', 'value': 2},
      ];

      return (
         <div>
            <div>
               <Message
                  error
                  header='** Penting!'
                  content='Data yang tampil sebelum filter adalah data STS 3 hari terakhir.'
               />
                  <Menu>
                     {(isAdmin() || isVerificator()) &&
                        <Menu.Item>
                           <Form.Field
                              control={Select}
                              search
                              onChange={this.onChangeStatus}
                              options={status_opt}
                              placeholder='Pilih Status'
                           />
                        </Menu.Item>
                     }
                     <Menu.Item>
                        <DateRangePicker
                           hideKeyboardShortcutsPanel
                           reopenPickerOnClearDates
                           showClearDates
                           minimumNights={0}
                           withPortal
                           showDefaultInputIcon
                           displayFormat="DD/MM/YYYY"
                           small={true}
                           numberOfMonths={2}
                           startDatePlaceholderText="Awal"
                           endDatePlaceholderText="Akhir"
                           startDateId="startDateId"
                           endDateId="endDateId"
                           isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                           startDate={startDate}
                           endDate={endDate}
                           onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                           focusedInput={this.state.focusedInput}
                           onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                        />
                     </Menu.Item>
                     <Menu.Item>
                        <Dropdown text='Pilih Menu' icon='angle down' floating labeled button className='icon'>
                           <Dropdown.Menu>
                              <Dropdown.Item icon='filter' onClick={this.onFilter} disabled={(startDate===null && endDate===null) || isFilter || requests} text='Filter data' />
                              {isAdmin() &&
                                 <Dropdown.Item icon='download' onClick={this.onOpenExport} disabled={requests} text='Export data' />
                              }
                              <Dropdown.Item icon='refresh' onClick={this.onRefresh} disabled={requests} text='Refresh' />
                           </Dropdown.Menu>
                        </Dropdown>
                     </Menu.Item>
                     <Menu.Item>
                        <Input type="text"
                           icon="search"
                           placeholder="Masukkan Nomor STS"
                           autoFocus
                           value={this.state.q}
                           style={{width:'300px'}}
                           onChange={this.searchSTS}
                           />
                     </Menu.Item>
                  </Menu>
                  <Segment loading={(this.state.loading_detail || requests)}>
                     <Table size='small' sortable celled>
                        <Table.Header>
                           <Table.Row>
                              <Table.HeaderCell colSpan='9'>
                                 <Pagination activePage={activePage}
                                    onPageChange={this.handlePaginationChange}
                                    totalPages={this.state.totalPages}
                                 />
                              </Table.HeaderCell>
                           </Table.Row>
                           <Table.Row>
                              <Table.HeaderCell style={{width:"10%"}}>Proses</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"3%"}}>No.</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"20%"}}>OPD</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"15%"}} sorted={column === 'no_sts' ? direction : null} onClick={this.handleSort('no_sts')}>
                                 Nomor STS
                              </Table.HeaderCell>
                              <Table.HeaderCell style={{width:"6%"}} sorted={column === 'created_at' ? direction : null} onClick={this.handleSort('created_at')}>
                                 Pembuatan
                              </Table.HeaderCell>
                              <Table.HeaderCell style={{width:"6%"}} sorted={column === 'tgl_realisasi' ? direction : null} onClick={this.handleSort('tgl_realisasi')}>
                                 Realisasi
                              </Table.HeaderCell>
                              {/* <Table.HeaderCell style={{width:"20%"}}>Verifikator</Table.HeaderCell> */}
                              <Table.HeaderCell style={{width:"6%"}}>Total BP</Table.HeaderCell>
                              <Table.HeaderCell>Total Nilai</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"30%"}}>Keterangan</Table.HeaderCell>
                           </Table.Row>
                        </Table.Header>
                        <Table.Body>
                           {data.length===0 &&
                              <Table.Row>
                                 <Table.Cell colSpan="9">Data tidak ditemukan</Table.Cell>
                              </Table.Row>}
                              {/* { !this.state.resultBermasalah ? */}
                              { data.map((item,i) => (
                                    <Table.Row key={i} style={{
                                       "backgroundColor": !item.tgl_realisasi && (isAdmin() || isVerificator()) ? "#f9cecd" : null,
                                    }}>
                                       <Table.Cell>
                                          <Button.Group size='mini'>
                                             <Button size='mini'
                                                color='blue'
                                                icon='block layout'
                                                index={i}
                                                text='Detail'
                                                onClick={this.onOpenDetail}
                                             />
                                             {!item.tgl_realisasi ?
                                                <Button size='mini'
                                                   color='red'
                                                   icon='trash layout'
                                                   index={i}
                                                   text='Batalkan'
                                                   onClick={this.onOpenBatalkan}
                                                />
                                                :
                                                <Button size='mini'
                                                   color='yellow'
                                                   icon='refresh layout'
                                                   index={i}
                                                   text='Reset'
                                                   onClick={this.onOpenUnverified}
                                                />
                                             }
                                          </Button.Group>
                                       </Table.Cell>
                                       <Table.Cell>{i+1+(activePage-1)*10}.</Table.Cell>
                                       <Table.Cell>{item.org_opd.nama}</Table.Cell>
                                       <Table.Cell>{item.no_sts}</Table.Cell>
                                       <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                                       <Table.Cell>
                                          { item.tgl_realisasi ? toDMYDate(item.tgl_realisasi) : "-" }
                                       </Table.Cell>
                                       <Table.Cell>{item.total_bp} BP</Table.Cell>
                                       <Table.Cell>{toIDR(item.total_nilai)}</Table.Cell>
                                       <Table.Cell>{ item.keterangan }</Table.Cell>
                                    </Table.Row>
                                 ))
                              }
                        </Table.Body>
                        <Table.Footer>
                           <Table.Row>
                              <Table.HeaderCell colSpan='9'>
                                 <Pagination activePage={activePage}
                                    onPageChange={this.handlePaginationChange}
                                    totalPages={this.state.totalPages}
                                 />
                              </Table.HeaderCell>
                           </Table.Row>
                        </Table.Footer>
                     </Table>
                  </Segment>
                  {this.state.is_edit &&
                     <ModalEdit
                        open={this.state.is_edit}
                        data_edit={this.state.data_edit}
                        onClose={this.onCloseEdit} />
                  }
                  {this.state.is_detail &&
                     <ModalDetail
                        open={this.state.is_detail}
                        data_detail={this.state.data_detail}
                        onClose={this.onCloseDetail} />
                  }

                  {this.state.is_export &&
                     <ExportModal
                        open={this.state.is_export}
                        onClose={this.onCloseExport}
                        data={this.state.data}
                     />
                  }
                  {this.state.is_verif &&
                     <DateModalVerif
                        open={this.state.is_verif}
                        onClose={this.onCloseVerif}
                        data_verif={this.state.data_verif}
                     />
                  }
               </div>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_sts/STSList.js